module.exports = __webpack_public_path__ + "img/tallied.6fb701fa.svg";